import type { IModule, ModuleContext } from '@punica/editor';
import { ModuleLifecycleState } from '@punica/editor';
import { MODULE_NAMES } from '@punica/editor';

import { ensureSecretAdornmentStyles } from '../view/helpers.js';

/**
 * Shell View module.
 * Depends on: kernel.commands
 */
export class ViewModule implements IModule {
  readonly name = MODULE_NAMES.SHELL.VIEW;
  readonly version = '1.0.0';
  readonly dependencies: readonly string[] = [MODULE_NAMES.KERNEL.COMMANDS];

  #state: ModuleLifecycleState = ModuleLifecycleState.CREATED;

  get state(): ModuleLifecycleState {
    return this.#state;
  }

  async bootstrap(context: ModuleContext): Promise<void> {
    const { punica, registry } = context;

    const commandsState = registry.getState(MODULE_NAMES.KERNEL.COMMANDS);
    if (commandsState !== ModuleLifecycleState.BOOTSTRAPPED) {
      throw new Error('kernel.commands must be bootstrapped before shell.view');
    }

    // View is exported directly, not as a namespace with manager
    if (!punica.shell?.View) {
      throw new Error('View API not available');
    }
  }

  async start(context: ModuleContext): Promise<void> {
    const { punica } = context;

    // Extensions that build a credential form as markup write the key
    // adornment themselves, so its stylesheet cannot wait for the first
    // `Helpers.createInput` call — a panel of hand-written inputs would render
    // the glyph at full strength and full text size.
    ensureSecretAdornmentStyles();

    // Initialize theme manager early to ensure CSS variables are set
    if (punica.shell?.View?.Theme?.manager) {
      try {
        await punica.shell.View.Theme.manager.initialize();
        console.log('[ViewModule] Theme manager initialized');
      } catch (err) {
        console.error('[ViewModule] Failed to initialize theme manager:', err);
      }
    }
  }
}
